import { token } from '@atlaskit/tokens';
import styled from 'styled-components';
import * as grid from 'view/styles/grid';

export const Container = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-top: ${token('space.negative.050', '-4px')};
`;

interface SelectContainerProps {
    marginRight?: number;
    selectWidth?: number;
}

export const SelectContainer = styled.div`
    /* stylelint-disable scale-unlimited/declaration-strict-value */
    width: ${(props: SelectContainerProps) =>
        `${props && props.selectWidth ? `${props.selectWidth}px` : `calc(50% - ${grid.multiple(0.5).px})`}`};
    margin-top: ${token('space.050', '4px')};
    margin-right: ${(props: SelectContainerProps) => `${props && props.marginRight ? props.marginRight : 0}px`};
`;
